module.exports = __webpack_public_path__ + "media/images/kv-9a28b0de4b07e9796a8e9608fa21efaa.jpg";